import * as React from 'react';
import { useMedia } from 'react-use';
import { Heading, Paragraph, Dimension } from '@hungryroot/ramen';
import {
  BreakpointQueryMedium,
  BreakpointSizeMedium,
} from '@hungryroot/tokens';
import styles from './PromoCard.module.css';

interface ImageProp {
  mobile: string;
  desktop: string;
  alt: string;
}

interface PromoItem {
  image: ImageProp;
  title: string;
  description: string;
  isPopular: boolean;
  value: string;
}

interface Props extends PromoItem {
  isSelected: boolean;
  isDisabled: boolean;
  onClick: (e: React.SyntheticEvent) => void;
}

const PopularTag = ({ isDesktop }: { isDesktop?: boolean }) => {
  return (
    <Dimension level={isDesktop ? 'two' : 'none'} className={styles.tag}>
      <Paragraph variant="caption">POPULAR</Paragraph>
    </Dimension>
  );
};

export const PromoCard = (props: Props) => {
  const {
    image,
    title,
    description,
    isPopular,
    isSelected,
    isDisabled,
    onClick,
    value,
  } = props;
  const isTablet = useMedia(BreakpointQueryMedium, false);

  return (
    <button
      className={`${styles.container} ${isSelected ? styles.selected : ''}`}
      value={value}
      onClick={onClick}
      disabled={isDisabled}
      aria-label={title}
    >
      <picture className={styles.picture}>
        <source
          srcSet={image.desktop}
          media={`(min-width: ${BreakpointSizeMedium})`}
        />
        <img
          src={image.mobile}
          alt={image.alt}
          width={120}
          height={120}
          className={styles.image}
        />
      </picture>
      <div className={styles.content}>
        {isPopular && !isTablet && <PopularTag />}
        <Heading variant="H6">{title}</Heading>
        <Paragraph variant="caption" className={styles.description}>
          {description}
        </Paragraph>
        {isPopular && isTablet && <PopularTag isDesktop />}
      </div>
    </button>
  );
};
